import { Reveal } from "./Reveal";

export const Decisions = () => (
  <section
    data-testid="decisions-section"
    className="border-t border-[#E2DFD7] bg-[#EFECE6]/50"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20 grid lg:grid-cols-12 gap-8 lg:gap-16 items-start">
      <Reveal className="lg:col-span-5">
        <h2
          data-testid="decisions-heading"
          className="text-2xl sm:text-3xl lg:text-4xl font-medium tracking-tight text-[#121413]"
        >
          Decisions over dashboards.
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7">
        <p
          data-testid="decisions-statement"
          className="text-base sm:text-lg leading-relaxed text-[#4A4D4A] max-w-2xl"
        >
          Shikra Energy is built to close the loop. Our fine-tuned dispatch
          strategies incorporate real-time decision making, to ensure that we
          always capture the maximum value your assets can deliver. Our
          cloud-based software stack ensures that your team is always in
          charge, and equipped with the site-specific information needed to
          make the best decisions.
        </p>
      </Reveal>
    </div>
  </section>
);
